import {  SYSTEM_CONFIG_CAPTCHA_API } from './../../shared/constants/api-endpoint';
import { apiClient } from "shared/plugins/http-service";
import { ICaptcha, IVerifyCaptchaResponse } from './global-value.models';

export const getCaptchaAPI = async () => {
  return await apiClient.getHttp<ICaptcha>(
    `${SYSTEM_CONFIG_CAPTCHA_API}`,
     undefined,
     false
  );
};

export const verifyCaptchaAPI = async (prvKey: string, token?: string) => {
  return await apiClient.postHttp<IVerifyCaptchaResponse>(
    `https://www.google.com/recaptcha/api/siteverify?secret=${prvKey}&response=${token}`,
     {},
     undefined,
     false
  );
};